<template>
  <TableTemplate
    v-model="tableResult"

    :columns="websiteColumns"
    :columnVariables="websiteColumnVariables"
    :capitalize="capitalize"
    :skeletonClass="skeletonClass"

    :page="page"
    :enable-sorting="true"

    @update-column-order="updateColumnOrder"
    @set-page="v => page = v"
    :on-row-click="showAllProducts"

    :max="max"

    ref="table"
  >
    <template #above>
      <TableHeader
        title="Leveranciers"
        :alwaysShowMultiSelectCheckbox="true"
        :removeColumnConfiguration="true"
        :refetch="refetch"
        :exportParams="exportEndpointParams"

        @customize-layout="customizeLayout"
      >
        <template #header-buttons-before="props">
          <slot name="header-buttons-before" v-bind="props"></slot>
        </template>
        <template #after-title>
          <HeaderButton class="ml-2"
            buttonTypeClass="btn-outline-primary btn-primary-secondary-outline"
            style="padding: 11px 8px"
            @click.native="addSupplier"
          >
            Leverancier toevoegen
          </HeaderButton>
        </template>
      </TableHeader>

      <div class="d-flex">
        <TableMainSearchField v-model="search"/>
        <RefreshBtn
          :loading="isLoadingTableResult"
          @click.native="refresh"
        />
      </div>
    </template>

    <template v-if="loaded" #row-action="{ item }">
      <TableActionDropdown
        class="drop"
        :item="item"
        :options="options(item, freshRefetch)"
      />
    </template>

    <template #empty-state>
      <EmptyStatePlaceholder
        title="Er zijn geen leveranciers"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
        </svg>
      </EmptyStatePlaceholder>
    </template>
  </TableTemplate>
</template>

<script>

import TableTemplate from 'src/layout/Table/TableTemplate'
import tableFieldOptions from "src/mixins/tableFieldOptions"
import TableSearchField from "src/components/Inputs/TableSearchField.vue"
import TableActionDropdown from "src/components/Inputs/TableActionDropdown.vue"
import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"
import HeaderButton from "src/components/Inputs/HeaderButton.vue"
import TableHeader from "src/components/Product/ProductTable/TableHeader.vue"
import TableMainSearchField from '../layout/TableMainSearchField.vue'
import RefreshBtn from '../layout/RefreshBtn.vue'

import TableCell from "src/components/Table/TableCell.vue"

import table from "src/mixins/table"

export default {
  metaInfo: {
    title: "Leveranciers",
  },
  components: {
    TableCell,
    TableMainSearchField,
    TableTemplate,
    TableSearchField,
    RefreshBtn,
    TableActionDropdown,
    TableHeader,
    EmptyStatePlaceholder,
    HeaderButton,
  },
  mixins: [
    tableFieldOptions,
    table({
      pageReference: 'suppliers',

      params: {
        name: "",
        sku: null,
        price: 0,
        website: "",
        search: "",
      },
      route: "/api/suppliers",
    }),
  ],
  methods: {
    showAllProducts(supplier) {
      this.$router.push(`/admin/all-products?suppliers=%255B%2522${supplier.uid}%2522%255D`)
    },
    addSupplier() {
      this.$pushModal({
        modal: "EditSupplier",
        toBind: {
          callback: this.freshRefetch,
        },
      })
    },
    editSupplier(supplier) {
      this.$pushModal({
        modal: "EditSupplier",
        toBind: {
          supplier: this.tableResult.find(item => item.uid === supplier.uid),
          callback: this.freshRefetch,
        },
      })
    },
    async deleteSupplier(uid) {
      await this.$handlePromise(
        this.axios.delete(`/api/suppliers/${uid}`)
      )
      this.$store.dispatch('clearCacheSearch', "suppliers")
      this.$success("Productgroup succesvol verwijderd!")
      this.freshRefetch()
    },
    confirmDelete(item) {
      this.$confirmAction(
        () => this.deleteSupplier(item.uid),
        {
          title: "Leverancier verwijderen",
          description: `Are you sure you want to delete the <b>${item.name}</b> product group?`,
          buttonSave: "Verwijderen",
        }
      )
    },
    options(item, freshRefetch) {
      return [
        {
          click: () => this.editSupplier(item),
          id: "update-table-element",
          name: "Leverancier bijwerken",
          icon: "nc-icon nc-ruler-pencil",
        },
        {
          click: () => this.confirmDelete(item, item.uid, freshRefetch),
          id: "delete-table-element",
          name: "Leverancier verwijderen",
          icon: "nc-icon nc-simple-remove",
        },
      ];
    },
  },
  computed: {
    table() {
      return this.$refs.table
    },
    websiteColumns() {
      return ['Naam']
    },
    websiteColumnVariables() {
      return ['name']
    },
    capitalize() {
      return [false]
    },
  },
}

</script>
